import { Component, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonContent, IonSelect, NavController, NavParams, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PASSWORD_PATTERN, birthdayValidator } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'reset-password-mfa-second-step',
  templateUrl: './reset-password-mfa-second-step.component.html',
  styleUrls: ['./reset-password-mfa-second-step.component.scss'],
})
export class ResetPasswordMFASecondStepComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChildren(IonSelect) ionSelect: QueryList<IonSelect>;

  public loginUrl;
  public error: any = null;
  public resetPasswordForm: FormGroup;

  public customer: CustomerModel;

  public passwordGroup: AbstractControl;
  public newPassword: AbstractControl;
  public confirmPassword: AbstractControl;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  public showPasswordReset: boolean;
  public hasToken: boolean;
  public customerid: any;
  public showForm: boolean = true;
  public updateSuccess: boolean = false;
  public showIncomplete: boolean = false;
  public showPassword: boolean;
  public showConfirmPassword: boolean;
  public tokenURL: string;
  public token: string;
  public legalAge: number;
  public resetPasswordType: string;
  public email: string;
  public customerId: string;
  public isIosWeb: boolean = false;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    // public authProvider: AuthenticationProviderService,
    public userSession: UserSessionService,
    public successMessageProvider: SuccessMessageService,
    public config: ConfigService,
    public utils: UtilsService,
    private events: EventsService,
    public navigator: Navigator,
    public authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private platform: Platform,
  ) {
    this.successMessageProvider.clearMessage();
    this.loginUrl = `${this.config.getConfig().LOBBY_URL}?r=0#load-dialog=login`;
    this.resetPasswordType = this.config.getConfig().FEATURE_PASSWD_RESET_STEP;
    //Fetch the Token from navParams logic
    this.token = this.navParams.get('token');
    if (this.resetPasswordType && this.resetPasswordType == "MFA") {
      this.email = this.navParams.get('email');
      this.customerId = this.navParams.get('customerId');
    }
    this.customerid = this.navParams.get('customerId');
    this.legalAge = this.config.getConfig().FEATURE_LEGAL_AGE ?? 18;
    this.changeSelectInterface();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.changeSelectInterface();
  }


  changeSelectInterface() {
    setTimeout(() => {
      this.ionSelect.forEach((ionSelect: IonSelect) => {
        if (ionSelect) {
          // changing the interface to alert if it is IOS Mobile
          ionSelect.interface = this.isIOSMobile() ? "alert" : "popover";
        }
      });
    }, 1000);
  }

  isIOSMobile() {
    return this.platform.is('ios') && this.platform.is('capacitor');
  }

  ngOnInit() {
    //this.getToken();
    this.isIosWeb = this.platform.is("ios") && this.platform.is("mobileweb");
    this.resetPasswordForm = new FormGroup({
      passwordGroup: new FormGroup({
        newPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
        confirmPassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(PASSWORD_PATTERN)]),
      }, this.passwordMatchValidator),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
    });

    this.passwordGroup = this.resetPasswordForm.get('passwordGroup');
    this.newPassword = this.passwordGroup.get('newPassword');
    this.confirmPassword = this.passwordGroup.get('confirmPassword');

    this.dateOfBirthGroup = this.resetPasswordForm.get('dateOfBirthGroup');
    this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
    this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
    this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');
  }

  handleLoginClick(): void {
    if (this.platform.is("capacitor")) {
      this.navigator.navigateTo("LoginComponent");
    } else {
      window.location.href = this.loginUrl;
    }
  }

  passwordMatchValidator(g: FormGroup) {
    return g.get('newPassword').value === g.get('confirmPassword').value ? null : { 'mismatch': true };
  }

  onSubmit() {
    this.successMessageProvider.clearMessage();

    if (this.resetPasswordType && this.resetPasswordType == "MFA") {
      this.authenticationService.callResetPasswordDOBAndToken(this.resetPasswordForm.value, this.email, this.token, this.customerId)
        .subscribe(
          (response: any) => {
            this.error = null;
            if (response && !!response.result) {
              this.error = null;
              this.successMessageProvider.setMessage("Your password has been reset.");
              this.events.publish("event:password:reset", {});
              this.content.scrollToTop(10);
              this.showForm = false;
              this.showIncomplete = false;
              this.updateSuccess = true;
            }
          },
          (error) => {
            switch (error.getErrorCode().toUpperCase()) {
              case 'INVALID_TOKEN':
                error.setErrorMessage('The token provided is invalid');
                this.showForm = false;
                break;
              case 'SECURE_NO_MATCH':
                error.setErrorMessage(error.getErrorMessage());
                break;
              case 'TOKEN_EXPIRED':
                error.setErrorMessage('The token provided is expired');
                this.showForm = false;
                break;
              case 'SECURE_MAX_ATTEMPTS_REACHED':
                error.setErrorMessage(error.getErrorMessage());
                this.showForm = false;
                break;
              case 'DOB_NO_MATCH':
                error.setErrorMessage(error.getErrorMessage());
                this.showForm = true;
                break;
              case 'CURRENT_PASS_NO_MATCH':
                error.setErrorMessage("Your new password can not match your current password.");
                this.showForm = true;
                break;
              default:
                this.showForm = true;
                error.setErrorMessage('Unable to update password. Please try again or contact support');
            }
            this.successMessageProvider.clearMessage();
            this.error = error;
            this.content.scrollToTop(10);
          }
        );
    } else {
      this.authenticationService.callChangePasswordByToken(this.resetPasswordForm.value, this.customerid, this.token)
        .subscribe(
          (response: any) => {
            this.error = null;
            if (response && !!response.result) {
              this.error = null;
              this.successMessageProvider.setMessage("Your password has been reset.");
              this.events.publish("event:password:reset", {});
              this.content.scrollToTop(10);
              this.showForm = false;
              this.updateSuccess = true;
            }
          },
          (error) => {
            switch (error.getErrorCode().toUpperCase()) {
              case 'INVALID_TOKEN':
                error.setErrorMessage('The token provided is invalid');
                this.showForm = false;
                break;
              case 'SECURE_NO_MATCH':
                error.setErrorMessage(error.getErrorMessage());
                break;
              case 'TOKEN_EXPIRED':
                error.setErrorMessage('The token provided is expired');
                this.showForm = false;
                break;
              case 'SECURE_MAX_ATTEMPTS_REACHED':
                error.setErrorMessage(error.getErrorMessage());
                this.showForm = false;
                break;
              case 'DOB_NO_MATCH':
                error.setErrorMessage(error.getErrorMessage());
                this.showForm = true;
                break;
              case 'CURRENT_PASS_NO_MATCH':
                error.setErrorMessage("Your new password can not match your current password.");
                this.showForm = true;
                break;
              default:
                this.showForm = true;
                error.setErrorMessage('Unable to update password. Please try again or contact support');
            }
            this.successMessageProvider.clearMessage();
            this.error = error;
            this.content.scrollToTop(10);
          }
        );
    }
  }


  goTologin() {
    window.location.assign(`${this.config.getConfig().LOBBY_URL}#load-dialog=login`);
    return false;
  }

  hidePassword(): void {
    this.showPassword = false;
    return;
  }

  unhidePassword(): void {
    this.showPassword = true;
    return;
  }

  hideConfirmPassword(): void {
    this.showConfirmPassword = false;
    return;
  }

  unhideConfirmPassword(): void {
    this.showConfirmPassword = true;
    return;
  }

  get months() {

    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (this.platform.is("capacitor")) {
      months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    let displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length - 1]);
      }
    }
    return displayDays;
  }

  get years() {
    const years = [];
    const min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (let i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }
}
